import { TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutContactLookup } from "./autogen/AutogenLayoutContactLookup";
import { ContactVerificationUtil } from "@mcleod/powerbroker/src/ContactVerificationUtil";

export class ContactLookup extends AutogenLayoutContactLookup {

    override onLoad() {
        this.tableContactLookup.addRowDisplayListener((event: TableRowDisplayEvent) => {
            const row = event.getTableRow()
            const data = row.data;
            if (data.get("phone") == null)
                data.set("phone", data.get("mobile_phone"))
            ContactVerificationUtil.updateVerificationImage(data, row.findComponentById("imageCarrierVerification"));
        })
    }
}
